// client/src/StreamedImage.js
import React, { useState, useEffect } from 'react';
import Spinner from './Spinner';

// Now accepts onImageClick prop
function StreamedImage({ imageId, onImageClick }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const imagePath = `/extracted_images/${imageId}`;

  useEffect(() => {
    const img = new Image();
    img.src = imagePath;
    const handleLoad = () => setIsLoading(false);
    const handleError = () => {
      setIsLoading(false);
      setHasError(true);
    };
    img.addEventListener('load', handleLoad);
    img.addEventListener('error', handleError);
    return () => {
      img.removeEventListener('load', handleLoad);
      img.removeEventListener('error', handleError);
    };
  }, [imagePath]);

  if (isLoading) {
    return <Spinner />;
  }

  if (hasError) {
    return (
      <div className="p-2 my-2 text-sm text-red-700 bg-red-100 border border-red-400 rounded-md">
        Error loading: {imageId}
      </div>
    );
  }

  return (
    <img
      src={imagePath}
      alt={imageId}
      onClick={() => onImageClick(imagePath)} // Make the image clickable
      className="max-w-xs my-2 rounded-lg shadow-md cursor-pointer transition-transform duration-200 hover:scale-105" // Add styles for interactivity
    />
  );
}

export default StreamedImage;